export default "__VITE_ASSET__DSrwCJCG__"